import React, { useRef, useState, useEffect } from "react";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
function Form(props) {
  const { type, service, shipment, setOpen } = props;
  console.log(type);

  if (type === "inquiry") {
    const CustomDropdown = ({ options, placeholder, defaultOption }) => {
      const [isOpen, setIsOpen] = useState(false);
      const [selectedOption, setSelectedOption] = useState(
        defaultOption || null
      );
      const dropdownRef = useRef(null);

      // Toggle the dropdown
      const toggleDropdown = (e) => {
        e.preventDefault(); // Prevent form submission
        setIsOpen(!isOpen);
      };

      // Close dropdown if clicked outside
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target)
          ) {
            setIsOpen(false);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () =>
          document.removeEventListener("mousedown", handleClickOutside);
      }, []);

      // Handle selecting an option
      const handleOptionClick = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
      };

      return (
        <div className="custom-dropdown w-full" ref={dropdownRef}>
          <button
            type="button"
            className="dropdown-btn"
            onClick={toggleDropdown}
          >
            {selectedOption || placeholder || "Select an option"}
            <span className="dropdown-arrow">▼</span>
          </button>
          {isOpen && (
            <div className="dropdown-content">
              {options.map((option, index) => (
                <div
                  key={index}
                  className="dropdown-option"
                  onClick={() => handleOptionClick(option)}
                >
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>
      );
    };
    return (
      <div className="form-container w-full">
        <CancelRoundedIcon
          className="close"
          fontSize=""
          onClick={() => {
            setOpen(false);
          }}
        />
        <h4 className="section-title black center">
          Submit <span className="orange">Your Inquiry</span>
        </h4>
        <form
          className="basket-form"
          name="inquiry"
          action="https://formsubmit.co/commercial@saharawinds.ke"
          method="POST"
          // action="/confirmation.html"
          // method="POST"
          // data-netlify="true"
        >
          <input type="hidden" name="_next" value="https://saharawinds.ke" />
          <input type="hidden" name="_captcha" value="false" />
          <input type="hidden" name="_subject" value="Inquiries" />
          <div>
            <label>Name</label>
            <input className="p-2 w-full" type="text" name="name" />
          </div>
          <div>
            <label>Company</label>
            <input className="p-2 w-full" type="text" name="company" />
          </div>
          <div>
            <label>Phone number</label>
            <input className="p-2 w-full" type="text" name="phone" />
          </div>
          <div>
            <label>E-mail</label>
            <input className="p-2 w-full" type="email" name="email" />
          </div>
          <div>
            <label className="message-label">Message</label>
            <textarea className="w-full p-2" name="message"></textarea>
          </div>
          <div>
            <label className="message-label">Inquiry</label>
            <CustomDropdown
              options={[
                "Air Freight Solutions",
                "Sea Freight Solutions",
                "Charter Air Freight Services",
                "Customs Clearance",
                "Cold Chain Management",
                "Warehousing",
                "Road and Railway Transport",
              ]}
              placeholder="Please Choose Your Inquiry Topic"
              defaultOption={service}
            />
          </div>
          <input type="hidden" name="inquiry" value={service} />
          <br />
          <button className="send-button">Send Message</button>
        </form>
      </div>
    );
  }
  if (type === "shipment") {
    const CustomDropdown = ({ options, placeholder, defaultOption }) => {
      const [isOpen, setIsOpen] = useState(false);
      const [selectedOption, setSelectedOption] = useState(
        defaultOption || null
      );
      const dropdownRef = useRef(null);

      // Toggle the dropdown
      const toggleDropdown = (e) => {
        e.preventDefault(); // Prevent form submission
        setIsOpen(!isOpen);
      };

      // Close dropdown if clicked outside
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target)
          ) {
            setIsOpen(false);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () =>
          document.removeEventListener("mousedown", handleClickOutside);
      }, []);

      // Handle selecting an option
      const handleOptionClick = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
      };

      return (
        <div className="custom-dropdown w-full" ref={dropdownRef}>
          <button
            type="button"
            className="dropdown-btn"
            onClick={toggleDropdown}
          >
            {selectedOption || placeholder || "Select an option"}
            <span className="dropdown-arrow">▼</span>
          </button>
          {isOpen && (
            <div className="dropdown-content">
              {options.map((option, index) => (
                <div
                  key={index}
                  className="dropdown-option"
                  onClick={() => handleOptionClick(option)}
                >
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>
      );
    };
    return (
      <div className="form-container w-full">
        <CancelRoundedIcon
          className="close"
          fontSize=""
          onClick={() => {
            setOpen(false);
          }}
        />
        <h4 className="section-title black center">
          Ship It Today <span className="orange">- Book Now!</span>
        </h4>
        <form
          className="basket-form"
          name="shipment"
          action="https://formsubmit.co/commercial@saharawinds.ke"
          method="POST"
          // action="/confirmation.html"
          // method="POST"
          // data-netlify="true"
        >
          <input type="hidden" name="_next" value="https://saharawinds.ke" />
          <input type="hidden" name="_captcha" value="false" />
          <input type="hidden" name="_subject" value="Shipment Booking" />

          <div>
            <label>Name</label>
            <input className="p-2 w-full" type="text" name="name" />
          </div>
          <div>
            <label>Company</label>
            <input className="p-2 w-full" type="text" name="company" />
          </div>
          <div>
            <label>Phone number</label>
            <input className="p-2 w-full" type="text" name="phone" />
          </div>
          <div>
            <label>E-mail</label>
            <input className="p-2 w-full" type="email" name="email" />
          </div>
          <div>
            <label className="message-label">Message</label>
            <textarea className="w-full p-2" name="message"></textarea>
          </div>
          <div>
            <label className="message-label">Shipment</label>
            <CustomDropdown
              options={[
                "Mango",
                "Avocado",
                "Pineapple",
                "Vegetables",
                "Flowers",
                "Meat",
                "Dangerous Goods (DGR Cargo)",
                "Pharma & Healthcare",
                "Humanitarian Support Logistics",
                "Machinery & Equipment",
                "Time-critical Logistics",
                "Fashion & Textile Shipments",
                "Live Animals & Live Seafood",
              ]}
              placeholder="Please Choose Your Inquiry Topic"
              defaultOption={shipment}
            />
          </div>
          <input type="hidden" name="shipment" value={shipment} />
          <br />
          <button className="send-button">Send Message</button>
        </form>
      </div>
    );
  }

  // Similar structure for shipment form type

  return (
    <div className="w-full">
      <h4 className="section-title black">
        Have Questions? <span className="orange">Let's Chat!</span>
      </h4>
      <form
        className="basket-form"
        name="contacts"
        action="https://formsubmit.co/commercial@saharawinds.ke"
        method="POST"
        // action="/confirmation.html"
        // method="POST"
        // data-netlify="true"
      >
        <input type="hidden" name="_next" value="https://saharawinds.ke" />
        <input type="hidden" name="_captcha" value="false" />
        <input type="hidden" name="_subject" value="Contact" />

        <div>
          <label>Name</label>
          <input className="p-2 w-full" type="text" name="name" />
        </div>
        <div>
          <label>Company</label>
          <input className="p-2 w-full" type="text" name="company" />
        </div>
        <div>
          <label>Phone number</label>
          <input className="p-2 w-full" type="text" name="phone" />
        </div>
        <div>
          <label>E-mail</label>
          <input className="p-2 w-full" type="email" name="email" />
        </div>
        <div>
          <label className="message-label">Message</label>
          <textarea className="w-full p-2" name="message"></textarea>
        </div>
        <br />
        <button className="send-button">Send Message</button>
      </form>
    </div>
  );
}

export default Form;
